import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";
import logoDark from "@/assets/logo-dark.png";
import opendeluxeLogo from "@/assets/opendeluxe-logo.png";
import opendeluxeLogoDark from "@/assets/opendeluxe-logo-dark.png";
import PageFooter from "@/components/PageFooter";

const Imprint = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle flex flex-col">
      {/* Header */}
      <header className="glass-card border-b border-border/30 sticky top-0 z-10 shadow-elegant">
        <div className="container mx-auto px-6 py-5">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src={logoDark} alt="untabbed.to logo" className="h-8 w-8 dark:hidden" />
              <img src={logo} alt="untabbed.to logo" className="h-8 w-8 hidden dark:block" />
              <h1 className="text-3xl font-display font-bold text-black dark:text-white tracking-tight">
                untabbed.to
              </h1>
            </Link>
            <Link to="/">
              <Button variant="outline" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 flex-1 max-w-4xl">
        <div className="glass-card shadow-card p-8 rounded-lg">
          <h2 className="text-3xl font-display font-bold text-foreground mb-6">Imprint</h2>
          
          <div className="space-y-6 text-foreground">
            <section>
              <h3 className="text-xl font-semibold mb-3">Information according to § 5 TMG</h3>
              <p className="text-muted-foreground leading-relaxed">
                opendeluxe UG<br />
                Teltower Damm 159<br />
                14167 Berlin<br />
                Germany
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Contact</h3>
              <p className="text-muted-foreground leading-relaxed">
                Phone: <a href="tel:+4915678521554" className="text-primary hover:text-primary-glow transition-colors">+49(0)15678-521554</a><br />
                Email: <a href="mailto:contact@opendeluxe.com" className="text-primary hover:text-primary-glow transition-colors">contact@opendeluxe.com</a><br />
                Website: <a href="https://opendeluxe.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-primary-glow transition-colors">https://opendeluxe.com</a>
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Represented by</h3>
              <p className="text-muted-foreground leading-relaxed">
                opendeluxe UG wird vertreten durch die persönlich haftende Gesellschafterin:<br />
                opendeluxe UG, Amtsgericht Berlin-Charlottenburg, HRB 205652B<br />
                Geschäftsführer: Hagen Hübel
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Commercial Register</h3>
              <p className="text-muted-foreground leading-relaxed">
                Registergericht: Amtsgericht Berlin-Charlottenburg<br />
                Handelsregister-Nummer: HRB 205652B
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">VAT ID</h3>
              <p className="text-muted-foreground leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                DE280473383
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Professional Liability Insurance</h3>
              <p className="text-muted-foreground leading-relaxed">
                Exali GmbH<br />
                Räumlicher Geltungsbereich: Im gesamten EU-Gebiet und den Staaten des Abkommens über den Europäischen Wirtschaftsraum
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Dispute resolution</h3>
              <p className="text-muted-foreground leading-relaxed">
                The European Commission provides a platform for online dispute resolution (OS):
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-primary-glow transition-colors ml-1">
                  https://ec.europa.eu/consumers/odr
                </a>.
                We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.
              </p>
            </section>
          </div>

          {/* Powered by OpenDeluxe Ventures */}
          <div className="mt-12 pt-8 border-t border-border/30">
            <div className="flex flex-col items-center gap-3">
              <p className="text-sm text-muted-foreground">Powered by</p>
              <a
                href="https://opendeluxe.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-80 flex items-end gap-2"
              >
                <img src={opendeluxeLogoDark} alt="OpenDeluxe" className="h-12 w-auto dark:hidden" />
                <img src={opendeluxeLogo} alt="OpenDeluxe" className="h-12 w-auto hidden dark:block" />
                <span className="text-2xl font-bold mb-3" style={{ color: '#a855f7' }}>ventures</span>
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <PageFooter />
    </div>
  );
};

export default Imprint;
